import { useAppStore, useVODStore } from '@/shared/store'
import { getErrorMessage } from '@/shared/lib'
import { useCallback, useState } from 'react'
import { useVODService } from '@/app/context/DIContext/DIServices'
import VodDetails from '../../../../../features/VOD/vodClasses/vodDetails'
import { vodTypeEpisodes, vodTypeSeries } from '@/shared/constants'

const useItemDetailsTOYA = () => {
    const [details, setDetails] = useState<VodDetails | null>(null)
    const [error, setError] = useState<unknown>()
    const { actualProfile } = useAppStore()
    const vodCachedDetails = useVODStore((state) => state.vodCachedDetails)
    const setVodCachedDetails = useVODStore(
        (state) => state.setVodCachedDetails
    )
    const { getVodDetails, getVodSeriesDetails } = useVODService()
    const { id: profileId } = actualProfile ?? {}

    const getItemDetails = useCallback(
        async (
            item: {
                productId: string | null
                assetType: string | undefined
                id: string
                serviceName?: string
            },
            isForceFetchDetails = false
        ) => {
            setDetails(null)
            const { productId, assetType, id } = item
            if (!productId || !assetType) return

            const cachedItem = vodCachedDetails.find(
                (element) => element.vodItemId === id
            )

            if (cachedItem && !isForceFetchDetails) {
                setDetails(cachedItem.details)
                return
            }

            try {
                const details = [vodTypeEpisodes, vodTypeSeries].includes(
                    assetType
                )
                    ? await getVodSeriesDetails(productId, assetType, profileId)
                    : await getVodDetails(productId, assetType, profileId)

                if (details) {
                    const vodItemDetails = new VodDetails(details)
                    setDetails(vodItemDetails)
                    setVodCachedDetails(id, vodItemDetails)
                }
            } catch (error) {
                getErrorMessage('useItemDetails', error)
                setError(error)
            }
            return () => setDetails(null)
        },
        [vodCachedDetails, getVodDetails, setVodCachedDetails]
    )
    return { details, getItemDetails, error }
}

export default useItemDetailsTOYA
